module.exports = __webpack_public_path__ + "img/BannerPatHome2.18df3ff5.webp";